/**
 * appointmentYears.js — Helper reutilizable para construir el listado de años
 * disponibles en selectores del módulo de citas y dashboards.
 *
 * Regla:
 *   start = min(MIN_DEFAULT_YEAR, año mínimo con citas en BD)
 *   end   = max(año actual + FUTURE_OFFSET, año máximo con citas futuras en BD)
 *
 * Sin valores mágicos en componentes. NO hay lista fija.
 */

const MIN_DEFAULT_YEAR = 2024;
const FUTURE_OFFSET = 20; // año_actual + 20

/**
 * Construye el array de años (asc) a partir de un rango opcional del backend.
 *
 * @param {object} [opts]
 * @param {number} [opts.minYearWithData]  Año mínimo con citas en BD (opcional).
 * @param {number} [opts.maxYearWithData]  Año máximo con citas en BD (opcional).
 * @returns {number[]}  Lista de años en orden ascendente.
 */
export function buildYearOptions({ minYearWithData, maxYearWithData } = {}) {
  const currentYear = new Date().getFullYear();
  const defaultEnd = currentYear + FUTURE_OFFSET;

  const start = Math.min(
    MIN_DEFAULT_YEAR,
    Number.isFinite(minYearWithData) ? minYearWithData : MIN_DEFAULT_YEAR
  );
  const end = Math.max(
    defaultEnd,
    Number.isFinite(maxYearWithData) ? maxYearWithData : defaultEnd
  );

  const years = [];
  for (let y = start; y <= end; y += 1) years.push(y);
  return years;
}

/**
 * Alias semántico para uso en JSX.
 */
export const getAvailableYears = buildYearOptions;
